import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { RequestTrackerService } from '../request-tracker.service';

@Injectable()
export class RequestTrackerInterceptor implements HttpInterceptor {
	constructor(private readonly requestTracker: RequestTrackerService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		this.requestTracker.incrementRequestCount();

		return next.handle(req).pipe(
			finalize(() => {
				this.requestTracker.decrementRequestCount();
			}),
		);
	}
}
